import { Center, Column, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { IPostingEntity } from '../../../domain/Postings';
import ConfirmPopup from '../../shared/ConfirmPopup';
import { PopupWarningIcon } from './PopupWarningIcon';
import { SuspendedPostingsList } from './SuspendedPostingsList';

const DESCRIPTION_WRAPPER_STYLE: React.CSSProperties = {
  width: '80%',
};

// center the description box (it sits in a plain block wrapper); 38px overrides ConfirmPopup's built-in description-to-button gap
const DESCRIPTION_PROP_STYLE: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'center',
  marginBottom: 38,
};


interface IPaymentFailedPopupProps {
  isOpen: boolean;
  failedPostings: IPostingEntity[];
  totalCount: number;
  onRetry: () => void;
  onPayLater: () => void;
}

export const PaymentFailedPopup = ({
  isOpen,
  failedPostings,
  totalCount,
  onRetry,
  onPayLater,
}: IPaymentFailedPopupProps) => {
  if (!isOpen || failedPostings.length === 0) {
    return null;
  }

  const renderDescription = () => {
    return (
      <Center style={DESCRIPTION_WRAPPER_STYLE}>
        <Column gap={4}>
          <Typography
            size="body_large"
            color={colors.neutral[500]}
          >
            Your payment couldn&apos;t be processed, the following [{totalCount}] jobs remain
            suspended. Please try a different payment method.
          </Typography>

          <SuspendedPostingsList postings={failedPostings} />

          <Typography
            size="body_large"
            color={colors.neutral[500]}
            textAlign="center"
          >
            For help, call or text our Customer Service team at (855) 879-4688.
          </Typography>
        </Column>
      </Center>
    );
  };

  return (
    <ConfirmPopup
      title="Payment Failed"
      description={renderDescription}
      descriptionStyle={DESCRIPTION_PROP_STYLE}
      Icon={PopupWarningIcon}
      leftButtonText="Pay Later"
      rightButtonText="Try Again"
      leftButtonAction={onPayLater}
      rightButtonAction={onRetry}
      closePopup={onPayLater}
      dismissiblePopup={false}
      showClosePopupIcon={false}
    />
  );
};
